import React, { useState } from 'react';
import CallAPI from '../../../../../adminpanel/components/commonComponents/AxiosHelper';
// import EUIComponents from "../../commonComponents/EUIComponents"
import Form from '../../../../../adminpanel/components/commonComponents/Form.v2';
// import "./steptwo.css";
import { Redirect } from 'react-router-dom';

const commonConnection = {
    forDatabases: {
        "connection_name": { "label": "Connection Name", "name": "connection_name", "type": "text", "requiredFlag": true },
        "dbhost": { "label": "Host IP", "name": "dbhost", "type": "text", "requiredFlag": true },
        "dbusername": { "label": "Username", "name": "dbusername", "type": "text", "requiredFlag": true },
        "dbpassword": { "label": "Password", "name": "dbpassword", "type": "password", "requiredFlag": true, 'eyeIcon': true },
        "dbport": { "label": "Port", "name": "dbport", "type": "text", "requiredFlag": true },
        "selectDB": {
            "label": "Select Database", "name": "selectDB", "type": "hide", "requiredFlag": true, options: [
                { "name": "Select Database", "value": "" },
                { "name": "Add Database", "value": "addDbName" },
                { "name": "Default Database (ORCL)", "value": "ORCL" }
            ]
        },
        "databasename": { "label": "Database Name", "name": "databasename", "type": "text", "requiredFlag": false }
    },
    forSFTP: {
        "connection_name": { "label": "Connection Name", "name": "connection_name", "type": "text", "requiredFlag": true },
        "dbhost": { "label": "Host IP", "name": "dbhost", "type": "text", "requiredFlag": true },
        "dbusername": { "label": "Username", "name": "dbusername", "type": "text", "requiredFlag": true },
        "dbpassword": { "label": "Password", "name": "dbpassword", "type": "password", "requiredFlag": true, 'eyeIcon': true },
        "dbport": { "label": "Port", "name": "dbport", "type": "text", "requiredFlag": true },
    }
}
let connectionData = {
    "mysql": commonConnection['forDatabases'],
    "files": {
        "createFile": { "label": "Upload File", "name": "createFile", id: "createFile", "type": "newFile", "accept": ".xlsx, .xls, .csv, .txt, .accdb", "span1": "1. Supported file format is .csv, .xlsx, .txt, .accdb", "span2": "2. Upload file of size below 500MB only.", "requiredFlag": true },
        "sheetName": { "label": "Sheet Name (Ensure sheet is active)", "name": "sheetName", "type": "hide", "requiredFlag": true },
        "targetTable": { "label": "Table Name", "name": "targetTable", "type": "text", "requiredFlag": true },
        "field_terminate": {
            "label": "Field seperated by?", "name": "field_terminate", "type": "dropdown", "requiredFlag": true, options: [
                { "name": "Comma (,)", "value": "," },
                { "name": "Semicolon (;)", "value": ";" },
                { "name": "Pipe (|)", "value": "|" }
            ]
        },
        "allColumnSize": { "label": "All Column Size", "name": "allColumnSize", "type": "hide", min: 5, max: 500, "requiredFlag": true }
    },
    "sftp": commonConnection['forSFTP'],
    "sqlsrv": commonConnection['forDatabases'],
    "hive": commonConnection['forDatabases'],
    "oracle": commonConnection['forDatabases'],
    "postgres": commonConnection['forDatabases'],
    "mysql_tally": commonConnection['forDatabases']
}

function StepTwo(props) {
    const [verify, setverify] = useState(false)
    const [error, seterror] = useState('');
    const [isLoading, setisLoading] = useState(false);
    const [state, setstate] = useState({
        isSwitchChecked: false,
        comboBoxSelectionOptions: [],
        value: '20',
        connectionData: JSON.parse(JSON.stringify(connectionData)),
        formValues: {}
    })
    let pullStatus = true;
    const [redirectPath, setRedirectPath] = useState(null)
    const fileTypes = ['.csv', 'application/vnd.ms-excel', 'text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/plain', 'application/msaccess']

    function handleFormSubmit(e) {
        e.preventDefault();
        var formData = {};
        let checkValidity = true;
        $("#connectionInfo").serializeArray().map(function (innerData) {
            if (checkValidity) {
                if (innerData.name === "selectDB" && innerData.value === "ORCL") {
                    formData['databasename'] = "ORCL"
                } else if (innerData.name === "selectDB" && innerData.value === "addDbName") {
                    delete formData[innerData.name]
                } else if (innerData.name === 'dbpassword') {
                    formData[`${innerData.name}`] = `${innerData.value}`
                } else if (innerData.name === 'dbport') {
                    checkValidity = checkSpecialChars(innerData.value, 'number') ? true : false
                    checkValidity ? formData[`${innerData.name}`] = `${innerData.value}` : null;
                } else if (['connection_name', 'targetTable', 'databasename'].indexOf(innerData.name) > -1) {
                    checkValidity = checkValidity ? (checkSpecialChars(innerData.value) ? false : true) : false
                    checkValidity ? formData[`${innerData.name}`] = `${innerData.value}` : null;
                } else if (innerData.name === 'dbhost') {
                    formData[`${innerData.name}`] = `${innerData.value}`
                } else if (innerData.name === 'dbusername') {
                    checkValidity = /^[a-zA-Z0-9-_@.]+$/.test(innerData.value) ? true : false
                    checkValidity ? formData[`${innerData.name}`] = `${innerData.value}` : null;
                }
            }
        })

        if (checkValidity === false) {
            alert('Please enter valid inputs!');
        } else {
            let postData = { "connection_type": props.initialData.connection_type, "connection_name": formData.connection_name, "connection_details": formData, "testConnection": verify == true ? false : true, "userId": props.authData.userId }
            let params = { "siteId": props.authData.siteId };
            if (props.initialData.connection_type === "files") {
                let actualFormData = new FormData()
                Object.keys(formData).map(function (innerData) {
                    actualFormData.append(innerData, formData[innerData])
                })
                let file = jQuery('#createFile')[0].files[0];
                let fileExtension = file.name.split('.')[file.name.split('.').length - 1].toLowerCase();
                if (fileTypes.some(fileType => file.type === fileType)) {
                    if (fileExtension === "csv" || fileExtension === "xlsx" || fileExtension === "xls" || fileExtension === "txt" || fileExtension === "accdb") {
                        if ((file.size / 1024 / 1024) <= 500) {
                            actualFormData.append('uploadedfile', file);
                            actualFormData.append('action', "create");
                            actualFormData.append('api_request', true);
                            actualFormData.append('user', encodePassword(props.authData.userId))
                            if (props.initialData.connectionId)
                                actualFormData.append('connectionId', props.initialData.connectionId);
                            fileUpload(actualFormData, params)
                        } else alert("Max File size of 500MB is allowed to upload");
                    } else alert("Sorry, " + file.name + " is invalid, allowed extensions are: .csv, .xlsx, .xls, .txt, .accdb")
                } else alert(file.type + " is not a supported format")
            } else sendToBackend(postData, params);
        }
    }

    const fileUpload = (postData, params) => {
        params['auth'] = "system";
        setisLoading(true);
        CallAPI('POST', '/app/system/pullClientData_v1', postData, params, 1, function (response) {
            setisLoading(false);
            if (response.status === true) {
                let tempInfoArr = response.information;
                pullStatus = tempInfoArr.every(el => el.status === true);
                if (pullStatus === false) {
                    alert(response.information[0]['error_message']);
                    if (response.information[0]['error_code'] == 611) {
                        let temp = { ...state }
                        temp.connectionData['files']["allColumnSize"]['type'] = 'number'
                        setstate(temp);
                    }
                } else {
                    alert(response.information[0]['information']);
                    setRedirectPath("/adminpanel/v2/apirequest/admin");
                }
                jQuery("#uploadFile").html(`Upload`);
            }
        }, props.authData);
    }

    const sendToBackend = (postData, getParams) => {
        setisLoading(true)
        seterror(null);
        let responseStatus;
        CallAPI('POST', '/app/add_database_connector', postData, getParams, 0, function (response) {
            setisLoading(false);
            responseStatus = response.status;
            if (response.status == true) {
                setverify(true);
            } else {
                setverify(false);
                seterror(response.error_message);
            }
            if (verify && responseStatus === true) {
                let decodedResponse = JSON.parse(decodePassword(response.information[0]))
                props.setConnectionType({
                    "connectionId": decodedResponse.id,
                    selectedStep: 3,
                    "connection_type": decodedResponse.connection_type,
                    "connection_name": decodedResponse.connection_name,
                })
            }
        }, props.authData);
    }

    function backEvent() {
        props.setConnectionType({ selectedStep: 1 });
    }

    function handleFormEvent(e) {
        if (e.target.files) {
            let fileName = e.target.files[0].name;
            let formData = { ...state }
            formData.connectionData['files']["createFile"]['text_value'] = fileName;
            if (fileName.split(".")[1] == "xlsx") {
                formData.connectionData['files']['sheetName']['type'] = "text";
            } else {
                formData.connectionData['files']['sheetName']['type'] = "hide";
            }
            if (fileName.split(".")[1] == "accdb") {
                formData.connectionData['files']['field_terminate']['type'] = "hide";
            } else {
                formData.connectionData['files']['field_terminate']['type'] = "dropdown";
            }
            setstate(formData)
        }
    }

    function handleDbChange(e) {
        let tempFormData = { ...state }
        tempFormData.connectionData['oracle']['selectDB']['text_value'] = e.target.value
        if (e.target.name === "selectDB") {
            switch (e.target.value) {
                case "ORCL":
                    tempFormData.connectionData['oracle']['databasename']['text_value'] = "ORCL"
                    tempFormData.connectionData['oracle']['databasename']['disabled'] = true
                    break
                case "addDbName":
                    tempFormData.connectionData['oracle']['databasename']['text_value'] = ""
                    tempFormData.connectionData['oracle']['databasename']['disabled'] = false
                    break
                case "":
                    tempFormData.connectionData['oracle']['databasename']['text_value'] = ""
                    tempFormData.connectionData['oracle']['databasename']['disabled'] = false
                    break
            }
            setstate(tempFormData)
        }
    }

    let pos = null;
    var components = null;

    if (props.initialData.connection_type === "files") {
        let dropDown = state.connectionData['files']
        components = (
            <>
                <Form label_array={dropDown} handleForm={handleFormEvent} />
            </>
        );
    } else if (props.initialData.connection_type === "oracle") {
        let formArray = state.connectionData['oracle']
        formArray['selectDB']['type'] = "dropdown"
        components = <Form label_array={formArray} handle_form_drop_down={handleDbChange} />;
    } else {
        components = <Form label_array={state.connectionData[`${props.initialData.connection_type}`]} />;
    }

    let classNameVar = verify ? "btn-success" : "btn-primary";
    let buttonName = verify ? "Save Connection" : "Test Connection";

    buttonName = props.initialData.connection_type === "files" ? "Upload" : props.initialData.connection_type === "mysql_tally" ? "Save Connection" : buttonName;

    let loadingButton = props.initialData.connection_type === "files" ? null : (isLoading ? <span className="spinner-border spinner-border-sm mg-x-5" role="status" aria-hidden="true"></span> : null);
    buttonName = isLoading ? "Loading" : buttonName;
    const error_alert = (
        <div className="alert alert-outline alert-danger d-flex justify-content-center align-items-center" role="alert">
            <i data-feather="alert-circle" className="mg-r-10"></i> {error}
        </div>
    );

    if (redirectPath) {
        return <Redirect to={redirectPath} />
    }
    return (
        <div className={`card ${pos === "center" ? "ht-100v" : ""}`}>
            <div className="card-header">{`Configuration for ${props.initialData.connection_type_label}`}</div>
            {/* <div className={`card-body ${pos === "center" ? "d-flex justify-content-center align-items-center position-relative" : ""}`} > */}
            <div className={`card-body`} >
                <form name={"connectionInfo"} className="add-connection-form" id={"connectionInfo"} onSubmit={handleFormSubmit} autoComplete={"off"} >
                    {components}
                    <div className="d-flex mg-b-25" >
                        <button className="btn btn-sm btn-uppercase btn-white flex-fill tx-spacing-1 mg-r-10" onClick={backEvent} id="back">Go Back</button>
                        <button className={`btn btn-sm flex-fill ${classNameVar}`} id={props.initialData.connection_type === "files" ? "uploadFile" : props.initialData.connection_type === "mysql_tally" ? "save" : "verify"} type="Submit">{loadingButton}{buttonName}</button>
                    </div>
                    {error ? error_alert : null}
                </form>
            </div>
        </div>
    );
}

export default StepTwo;